import XHRPromise from 'xhr-promise'
const flexBookingFeed = '/feeds/AnytimeCover.aspx';

class FlexibleBooking {
    constructor() {
        this.flexibleBookingContainer = document.getElementsByClassName('cancel-anytime-wrapper')[0]
        this.flexibleBookingPrice = document.querySelectorAll('.cancel-anytime__item--price.flexible')[0]
        this.standardBookingPrice = document.querySelectorAll('.cancel-anytime__item--price.standard')[0]
        this.flexibleBookingDoc = document.querySelectorAll('.cancel-anytime__item-link.flexible')[0]
        this.flexibleBookingRadio = document.querySelectorAll('.cancel-anytime__item--radio.flex')[0]
        this.standardBookingRadio = document.querySelectorAll('.cancel-anytime__item--radio.standard')[0]
    }

    calcFlexibleBookingControl(price, broRent, updateStandardPrice = true) {
        const xhr = new XHRPromise()
        return xhr.send({
            url: `${flexBookingFeed}?r=${price}`,
        })
            .then(response => (new window.DOMParser()).parseFromString(response.responseText, 'text/xml'))
            .then((data) => {
                this.displayFlexBooking(price, data, broRent, updateStandardPrice)
                return data
            })
    }
    
    displayFlexBooking(rentPrice, data, broRent, updateStandardPrice) {
        if (!this.standardBookingRadio.checked && !this.flexibleBookingRadio.checked) {
            this.standardBookingRadio.checked = true
        }

        const result = data.getElementsByTagName('coverDetails')[0]
        
        const coverCost = this.roundToTwoDecimalPlaces(result.getAttribute('coverCost'))
        const totalCost = this.roundToTwoDecimalPlaces(parseFloat(broRent) + parseFloat(coverCost))
        const doc = result.getAttribute('doc')

        if (coverCost > 0) {
            rentPrice = this.roundToTwoDecimalPlaces(rentPrice)

            this.flexibleBookingRadio.setAttribute('data-cost', totalCost)

            this.flexibleBookingPrice.innerHTML = totalCost
            this.flexibleBookingPrice.setAttribute('data-flex-cost', coverCost)

            this.flexibleBookingDoc.setAttribute('href', doc)

            if (updateStandardPrice) {
                this.standardBookingPrice.setAttribute('data-standard-cost', this.roundToTwoDecimalPlaces(broRent))
                this.standardBookingPrice.innerHTML = this.roundToTwoDecimalPlaces(broRent)
            }
        }
        this.flexibleBookingContainer.setAttribute('aria-hidden', (totalCost <= 0))
    }
    getSelectedPrice() {
        return this.standardBookingRadio.checked ? this.standardBookingPrice : this.flexibleBookingPrice
    }
    getSelectedOption() {
        return this.standardBookingRadio.checked ? this.standardBookingRadio : this.flexibleBookingRadio
    }

    roundToTwoDecimalPlaces(price) {
        price = parseFloat(price);
        return price.toFixed(2);
    }
}

export default FlexibleBooking
